import defaultCover from "../../styles/assets/background/sedan_hero.webp";

import defaultLogo from "../../../assets/logo.png";

const S3_BUCKET = "s3-zakupauto-service";
const S3_REGION = "eu-central-1";

const asUrl = (asset: string | {src?: string}): string => (typeof asset === "string" ? asset : asset.src || "");

/** Absolute URL from S3 object key (same bucket as offer galleries). */
export const sellerAssetUrlFromKey = (key?: string | null): string => {
    const trimmed = (key || "").trim();
    if (!trimmed) {
        return "";
    }
    if (/^https?:\/\//i.test(trimmed)) {
        return trimmed;
    }
    return `https://${S3_BUCKET}.s3.${S3_REGION}.amazonaws.com/${trimmed.replace(/^\/+/, "")}`;
};

/**
 * Prefer explicit URL; fall back to S3 key.
 * Accepts common alternate field names from WP profile payloads.
 */
export const pickSellerImageUrl = (fields: {url?: string | null; key?: string | null; altUrl?: string | null; altKey?: string | null}): string => {
    const direct = (fields.url || fields.altUrl || "").trim();
    if (direct) {
        return direct;
    }
    return sellerAssetUrlFromKey(fields.key || fields.altKey);
};

/** Cover: seller upload → brand hero (never a single offer photo). */
export const resolveSellerCoverUrl = (coverUrl?: string | null, coverKey?: string | null): string => {
    const custom = pickSellerImageUrl({url: coverUrl, key: coverKey});
    return custom || asUrl(defaultCover);
};

/** Logo (small profile image): seller upload → zakupauto mark. */
export const resolveSellerLogoUrl = (logoUrl?: string | null, logoKey?: string | null): string => {
    const custom = pickSellerImageUrl({url: logoUrl, key: logoKey});
    return custom || asUrl(defaultLogo);
};

export const isDefaultSellerLogo = (logoUrl?: string | null, logoKey?: string | null): boolean => !pickSellerImageUrl({url: logoUrl, key: logoKey});

export const isDefaultSellerCover = (coverUrl?: string | null, coverKey?: string | null): boolean => !pickSellerImageUrl({url: coverUrl, key: coverKey});
